import { _ as c, x as S, f as p, b as y, r as m, E as $, Q as A, t as E, N as b, D as O } from "./export-cdcbfb2b.js";
import { b as h, a as x, c as F } from "./create-property-f9780ed1.js";
import { c as R, n as _ } from "./correct-is-regexp-logic-4465cd47.js";
import { t as C } from "./to-string-92a62764.js";
import { b as I, i as T } from "./array-iteration-759bfbfa.js";
var N = c, P = S.includes, j = p, w = h, L = j(function() {
  return !Array(1).includes();
});
N({ target: "Array", proto: !0, forced: L }, {
  includes: function(e) {
    return P(this, e, arguments.length > 1 ? arguments[1] : void 0);
  }
});
w("includes");
var D = c, M = y, U = _, V = m, l = C, k = R, B = M("".indexOf);
D({ target: "String", proto: !0, forced: !k("includes") }, {
  includes: function(e) {
    return !!~B(
      l(V(this)),
      l(U(e)),
      arguments.length > 1 ? arguments[1] : void 0
    );
  }
});
var K = TypeError, q = 9007199254740991, H = function(r) {
  if (r > q)
    throw K("Maximum allowed index exceeded");
  return r;
}, G = c, Q = p, X = T, z = O, J = E, W = b, v = H, f = F, Y = I, Z = x, rr = $, er = A, g = rr("isConcatSpreadable"), ar = er >= 51 || !Q(function() {
  var r = [];
  return r[g] = !1, r.concat()[0] !== r;
}), tr = function(r) {
  if (!z(r))
    return !1;
  var e = r[g];
  return e !== void 0 ? !!e : X(r);
}, nr = !ar || !Z("concat");
G({ target: "Array", proto: !0, arity: 1, forced: nr }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function(e) {
    var u = J(this), s = Y(u, 0), a = 0, n, o, d, i, t;
    for (n = -1, d = arguments.length; n < d; n++)
      if (t = n === -1 ? u : arguments[n], tr(t))
        for (i = W(t), v(a + i), o = 0; o < i; o++, a++)
          o in t && f(s, a, t[o]);
      else
        v(a + 1), f(s, a++, t);
    return s.length = a, s;
  }
});
export {
  H as d
};
